import {createMultiStyleConfigHelpers, cssVar, defineCssVars, defineStyle} from '@chakra-ui/styled-system';
import {useMultiStyleConfig} from '@chakra-ui/system';
import {mode} from '@chakra-ui/theme-tools';

import {semantic} from '../../design-tokens/light';

const parts = [`container`, `header`, `body`, `footer`] as const;
export type CardParts = (typeof parts)[number];

const cardThemeConfigHelpers = createMultiStyleConfigHelpers(parts);

const $background = cssVar(`linx-colors-background-body`);
const $vars = defineCssVars(`card`, [`border-color`]);

const partsConfig = cardThemeConfigHelpers.definePartsStyle({
  container: {
    boxShadow: `none`,
    backgroundColor: $background.reference,
  },
  header: {
    boxShadow: `none`,
  },
  body: {
    boxShadow: `none`,
  },
  footer: {
    baseStyle: {},
  },
});

const CardTheme = cardThemeConfigHelpers.defineMultiStyleConfig({
  baseStyle: defineStyle(props => ({
    ...partsConfig,
    [$vars[`border-color`].variable]: mode(semantic.colors.stroke.primary, semantic.colors.stroke.primary)(props),
  })),
  variants: {
    elevated: {
      container: {
        boxShadow: `4`,
      },
    },
    embedded: {
      container: {
        boxShadow: `4.inset`,
      },
      header: {
        boxShadow: `none`,
      },
      body: {
        boxShadow: `none`,
      },
    },
    outlined: {
      container: {
        border: `base`,
        borderRadius: `lg`,
        boxShadow: `none`,
        backgroundColor: `transparent`,
      },
    },
  },
  defaultProps: {
    variant: `elevated`,
  },
});

export const useCardStyleConfig = <Part extends CardParts>(
  part: Part,
  props?: Parameters<typeof useMultiStyleConfig>[1],
): (typeof partsConfig)[Part] => {
  return useMultiStyleConfig(`Card.${part}`, props ?? {}) as (typeof partsConfig)[Part];
};

export default CardTheme;
